import { Component, OnInit  } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-loader',
  templateUrl: `./${environment.pageFolder}/loader.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/loader.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: []
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
